// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]8.0.21-13222(7c48aee7e6)-C15/09/2026-07:55:07-B15/09/2026-08:01:22' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]8.0.21-13222(7c48aee7e6)-C15/09/2026-07:55:07-B15/09/2026-08:01:22",
  branch: "production",
  latestTag: "8.0.21",
  revCount: "13222",
  shortHash: "7c48aee7e6",
  longHash: "7c48aee7e673da874668510490c4d12888fa3473",
  dateCommit: "15/09/2026-07:55:07",
  dateBuild: "15/09/2026-08:01:22",
  buildType: "Ansible",
  } ;
